import { useState, type ReactNode } from 'react'
import type { Role } from '@/lib/types'
import type { ReviewDetail } from './types'
import { ReviewRollouts } from './ReviewRollouts'
import { BuilderSubmission } from './BuilderSubmission'
import { QualityPrompt, QualityBrief } from './QualityContent'
import { PeerExecution } from './PeerExecution'
import { Markdown } from '@/components/Markdown'

/** Put review evidence on the page; only the optional, longer chat needs opening. */
export function WorkReview({
  data,
  role,
  active,
  feedback,
  coach,
}: {
  data: ReviewDetail
  role: Role
  active: boolean
  feedback: ReactNode
  coach?: ReactNode
}) {
  const [coachOpen, setCoachOpen] = useState(false)
  const quality = data.round.kind === 'quality'
  const preparing = data.round.status === 'preparing'
  const task = data.submission.task
  // Scientific packages have a compiled prompt, without a human execution brief.
  return (
    <div className="work-review-evidence">
      {quality && !preparing && (
        <ReviewRollouts taskId={data.round.task_id} roundId={data.round.round_id} active={active} />
      )}
      {quality && task.scientific && <section className="box"><h3>Task prompt</h3><Markdown source={task.prompt} /></section>}
      {quality && !task.scientific && (
        <>
          <section className="box">
            <h3>Agent prompt</h3>
            <QualityPrompt prompt={task.prompt} changes={data.quality_changes} />
          </section>
          <section className="box">
            <h3>Task brief</h3>
            <QualityBrief brief={task.brief} changes={data.quality_changes} />
          </section>
          <details className="box" open={preparing}>
            <summary>Expert execution and files</summary>
            <PeerExecution
              base={`/tasks/${data.round.task_id}/reviews/${data.round.round_id}`}
              submission={data.submission}
              active={active}
            />
          </details>
        </>
      )}

      {quality && feedback}
      {quality && <BuilderSubmission task={data.submission.task} role={role} />}
      {!quality && coach && (
        <details className="box" onToggle={(event) => setCoachOpen(event.currentTarget.open)}>
          <summary>Peer coach conversation</summary>
          {coachOpen && coach}
        </details>
      )}
    </div>
  )
}
